import { Injectable, Inject, inject, effect } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { environment } from "src/environments/environment";
// import { WhiteLabel } from "../appdata/auth.model";
import { Store } from "@ngrx/store";
import { IWlbServiceData } from "../common/models/white-label-service.model";
// import * as commonActions from "src/app/store/common.actions";
import { encryptData } from "src/app/common/functions/crypto.functions";
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WhiteLabelService {
    private _wlbSubject = new BehaviorSubject<IWlbServiceData | null>(null);
    readonly wlb$ = this._wlbSubject.asObservable();

    constructor(
        @Inject(DOCUMENT) private _document: Document,
        private store: Store
    ) {
        // On service init, try to read existing value from localStorage and emit it
        const wld = localStorage.getItem('wld');
        if (wld) {
            try {
                // decryptData isn't imported here; callers using this service usually decrypt in components
                // But the stored value is the encrypted form set by applyWhiteLabeling; emit raw string if needed
                // Instead, attempt to parse using existing code path from consumers if they decrypt.
                // We'll emit null here and let applyWhiteLabeling emit when used. Keeping emission minimal.
            } catch { }
        }
    }


    // WhiteLabel
    applyWhiteLabeling(data: IWlbServiceData) {
        // if (!data) {
        //   this.store.dispatch(
        //     commonActions.setWhiteLabelData({
        //       data: atob(localStorage.getItem("waba_wbl")),
        //     })
        //   );
        // }

        // localStorage.setItem("wld", JSON.stringify(data));
        localStorage.setItem("wld", encryptData(data));

        this._document.documentElement.style.setProperty(
            "--primary",
            data.primary_color
        );
        this._document.documentElement.style.setProperty(
            "--secondary",
            data.secondary_color
        );
        this._document.documentElement.style.setProperty(
            "--primary-rgb",
            this.hexToRgb(data.primary_color)
        );
        this._document.documentElement.style.setProperty(
            "--secondary-rgb",
            this.hexToRgb(data.secondary_color)
        );

        if (data.buttons_type === "pilled") {
            this._document.documentElement.style.setProperty(
                "--btn-border-radius",
                "50rem"
            );
        } else if (data.buttons_type === "rounded") {
            this._document.documentElement.style.setProperty(
                "--btn-border-radius",
                "0.438rem"
            );
        }
        if (data.formcontrol_type === "pilled") {
            this._document.documentElement.style.setProperty(
                "--fc-border-radius",
                "50rem"
            );
            this._document.documentElement.style.setProperty(
                "--fc-select-open-border-radius",
                "1.3rem"
            );
        } else if (data.formcontrol_type === "rounded") {
            this._document.documentElement.style.setProperty(
                "--fc-border-radius",
                "0.438rem"
            );
            this._document.documentElement.style.setProperty(
                "--fc-select-open-border-radius",
                "0.438rem"
            );
        }

        this._document.getElementById("appFavicon")?.setAttribute("href", data.favicon);

        this._document.getElementById("dynamic_product_image")?.setAttribute("src", data.dashboard_logo);
        this._document.getElementById("login_main_logo")?.setAttribute("src", data.logo);

        // Set login_left background image if provided
        if (data.loginbackgroundimg) {
            Array.from(this._document.getElementsByClassName("login_left")).forEach(
                (el) => (el as HTMLElement).style.backgroundImage = `url('${data.loginbackgroundimg}')`
            );
        }

        let copyRightsTag = this._document.getElementById("copyRightsTag") as HTMLAnchorElement;
        if (copyRightsTag) {
            copyRightsTag.setAttribute("href", data.website);
            copyRightsTag.innerHTML = data?.company_name || "";
        }

        let companyName = this._document.getElementById("companyName") as HTMLTitleElement;
        if (companyName) {
            companyName.innerHTML = data?.company_name || "";
        }

        // Notify subscribers about the updated white-label data
        try {
            this._wlbSubject.next(data);
        } catch (e) {
            // swallow errors to avoid breaking the UI
        }
    }

    hexToRgb(hex: string) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (result) {
            const r = parseInt(result[1], 16);
            const g = parseInt(result[2], 16);
            const b = parseInt(result[3], 16);
            return r + "," + g + "," + b; //return 23,14,45 -> reformat if needed
        }
        return null;
    }
}